var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt-details"},[_c('div',{staticClass:"dt-details--header"},[_vm._v("\n      "+_vm._s(_vm.$t('user_details_for'))+" "+_vm._s(_vm.userDetails.usr.user_name)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }